import { render, staticRenderFns } from "./StartSearchState.vue?vue&type=template&id=60979cbe"
import script from "./StartSearchState.vue?vue&type=script&lang=js"
export * from "./StartSearchState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports